<template>
  <div class="description">
    <v-title class="title">{{ title }}</v-title>
    <slot />
  </div>
</template>

<script>
import VTitle from '@/components/common/Title.vue';

export default {
  components: {
    VTitle,
  },
  props: {
    title: String,
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/fonts';
@import '~@/assets/styles/colors';
@import '~@/assets/styles/breakpoints';

.description {
  font-size: $font-size-small;
  color: $text-grey;
  margin: 40px 0 32px 0;
  max-width: 688px;
}

span {
  letter-spacing: 0.11px;
  line-height: 18px;
}

.title {
  display: none;
}

@media (max-width: $header-breakpoint) {
  .title {
    display: block;
    padding-bottom: 15px;
    margin: 0;
  }
}
</style>
